import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import axios from "../../components/axios";
import useFullPageLoader from "../../components/useFullPageLoader";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";
import { useUser } from "../../components/UserContext";
import Select from "react-select"
import PreviewDocumntes from "../../components/PreviewDocumntes";



const SendAnnualReturn = ({ open, onClose, agentData }) => {
    const { userData } = useUser();
    const [loader, showLoader, hideLoader] = useFullPageLoader();
    const [show, setShow] = useState(open);
    const [errors, setErrors] = useState({
        Certificate_Name: '',
        Customer_Company: '',
        Remarks: '',
    });    const navigate = useNavigate();
    const [isEditing, setIsEditing] = useState(false);
    const [certificateOption, setCertificateType] = useState([]);
    const [IsModal, setIsModal] = useState(null);


    const showModal = () => {
        setIsModal(true);
        //handleClose();
      };
      const closed = () => {
        setIsModal(false);
      };

  
    const [agent, setAgent] = useState({
        Certificate_Id: "",
        Certificate_Name: "",
        Annual_Return_Type:"",
        Remarks: ""
    });

    const handleClose = () => {
        setShow(false);
        onClose();
    };


    useEffect(() => {
        fetchData();
    }, [userData]);

    const fetchData = async () => {
        showLoader();
        try {
            const certificateType = await axios.get(`/getCertificateType`);
            const Option = certificateType.data.map((option) => ({
                label: option.Certificate_Name,
                value: option.Sr_No,
            }));
            setCertificateType(Option);
            // if (userData?.UserId) {
            //     const result = await axios.get(`/getCustomerById/${userData?.UserId}`);
            //     console.log(result.data);
            //     setCustomer(result.data);
            // }
        } catch (error) {
            console.error("Error fetching:", error);
        }
        hideLoader();
    };


    const UploadCustomerHandle = async (event) => {
        event.preventDefault();
    
    
        let validationErrors = {};
        let isValid = true;
    
        // Validation logic
        if (!agent.Certificate_Id) {
            validationErrors.Certificate_Name = 'Certificate Type is required';
            isValid = false;
          }
        //   if (!agent.Remarks) {
        //     validationErrors.Remarks = 'Remarks are required';
        //     isValid = false;
        //   }
          if (!agent.Annual_Return_Type) {
            validationErrors.Annual_Return_Type = "Annual Return Type is required.";
            isValid = false;
          }
          
    
        if (!isValid) {
            setErrors(validationErrors);
            return;
        }
    
        const obj = {
            ...agent,
            Enquiry_Sr_No: agentData?.Enquiry_Sr_No,
            Enquiry_Id: agentData?.Enquiry_Id,
            Customer_Id: agentData?.Enquiry_CustomerId,
            Customer_Company: agentData?.Customer_Company || agentData?.Company_Name,
            Added_By: `${userData?.First_Name} ${userData?.Last_Name}`,
            Added_By_Id: userData?.UserId,
            Updated_By: `${userData?.First_Name} ${userData?.Last_Name}`,
            Updated_By_Id: userData?.UserId,
        };
    
    
        showLoader();
    
        try {
            const res = await axios.post(`/sendAnnualReturn`, obj);
    
            if (res.status === 200) {
                Swal.fire("Success!", "Applied Successfully.", "success");
                handleClose();
                navigate('/viewAnnualReturn')
            } else {
                Swal.fire({
                    title: "Error",
                    text: "Failed to apply. Unexpected server response.",
                    icon: "error",
                    confirmButtonText: "OK",
                });
            }
        } catch (err) {
            console.error("Error during request:", err);
            Swal.fire({
                title: "Error",
                text: "Failed to Apply. Please try again later.",
                icon: "error",
                confirmButtonText: "OK",
            });
        } finally {
            hideLoader();
        }
    };
    
    
    


    return (
        <Modal
            show={show}
            onHide={handleClose}
            size="xl"
            centered
            style={{ boxShadow: "none !important" }}
        >   <Modal.Body>
                <h5>Send Annual Return</h5>
                <hr className="p-0 mb-2" />
                <form onSubmit={UploadCustomerHandle}>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="mb-2">
                                <label htmlFor="Bank" className="col-form-label">
                                    Certificate Type<span style={{ color: "red" }}>*</span>
                                </label>
                                <Select type="text" name="Bank" id="Bank" className="selecting"
                                    options={certificateOption} 
                                    styles={{
                                        option: (provided, state) => ({
                                            ...provided,
                                            color: state.isSelected ? 'white' : 'black',
                                            backgroundColor: state.isFocused ? 'blue' : 'white',
                                            '&:hover': {
                                                backgroundColor: 'blue', 
                                                color: 'white', 
                                            },
                                        }),
                                    }}
                                    onChange={(e) =>
                                        setAgent({
                                            ...agent,
                                            Certificate_Id: e.value,
                                            Certificate_Name: e.label,
                                        })
                                    }
                                />
                                <p className="text-danger">{errors.Certificate_Name}</p>
                            </div>
                        </div>
                        <div className="col-md-6">
  <div className="mb-2">
    <label htmlFor="Annual_Return_Type" className="col-form-label">
      Annual Return Type<span style={{ color: "red" }}>*</span>
    </label>
    <select
      id="Annual_Return_Type"
      className="form-select"
      onChange={(e) =>
        setAgent({
          ...agent,
          Annual_Return_Type: e.target.value, // Update the value based on dropdown selection
        })
      }
    >
      <option value="">Select Annual Return Type</option>
      <option value="Financial Year">Financial Year</option>
      <option value="Application Date">Application Date</option>
    </select>
  </div>
  <p className="text-danger">{errors.Annual_Return_Type}</p>
</div>

                        <div className="col-md-12">
                            <div className="mb-2">
                                <label htmlFor="Remarks" className="col-form-label">
                                    Remarks
                                </label>
                                <textarea
                                    id="Remarks"
                                    className="form-control"
                                    placeholder="Enter Remarks"
                                    onChange={(e) =>
                                        setAgent({
                                            ...agent,
                                            Remarks: e.target.value,
                                        })
                                    }
                                />
                            </div>
                            <p className="text-danger">{errors.Remarks}</p>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-12 text-center">
                            <button className="btn btn-primary btn-sm mt-2" type="submit">
                                Apply
                            </button>
                        </div>
                    </div>
             </form>
                {loader}
            </Modal.Body>
        </Modal>
    );
}
export default SendAnnualReturn;
